<template>
  <!-- overview section -->
  <section class="xb-section-container">
    <h2 class="underline">
      {{ profileType === 1 ? "KEO Eligibility" : "Overview" }}
    </h2>
    <template v-if="profileType === 1 && hasNoKEO"
      >No Key Executive Officer data available at the moment.</template
    >
    <template v-else>
      <b-notification
        class="xb-notification xb-notification-icon"
        type="is-danger"
        :active="notification.isActive"
        has-icon
        :message="notification.message"
        @close="notification.isActive = false"
      />

      <div v-if="!isFetchingCPDCPFData" class="columns is-multiline is-tablet">
        <div
          v-for="(cta, idx) in ctaData"
          :key="idx"
          class="column is-full-tablet is-half"
        >
          <xb-cta
            :title="cta.title"
            :content="cta.content"
            :subContent="cta.subContent"
            :type="cta.type"
            dangerImageIconPath="/aceas/assets/common/vendor/xbase/img/icon/times.png"
            successImageIconPath="/aceas/assets/common/vendor/xbase/img/icon/checklist.png"
          />
        </div>
      </div>

      <template v-else>
        <div class="columns is-multiline">
          <div class="column xb-card-sb-wrapper is-half">
            <div class="media section xb-outline is-rounded">
              <figure class="media-left">
                <p class="image is-64x64">
                  <b-skeleton circle width="64px" height="64px"></b-skeleton>
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p>
                    <b-skeleton active height="20px" width="90%"></b-skeleton>
                    <b-skeleton height="20px" width="60%"></b-skeleton>
                    <b-skeleton height="20px" width="70%"></b-skeleton>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="column xb-card-sb-wrapper is-half">
            <div class="media section xb-outline is-rounded">
              <figure class="media-left">
                <p class="image is-64x64">
                  <b-skeleton circle width="64px" height="64px"></b-skeleton>
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p>
                    <b-skeleton active height="20px" width="90%"></b-skeleton>
                    <b-skeleton height="20px" width="60%"></b-skeleton>
                    <b-skeleton height="20px" width="70%"></b-skeleton>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </section>
</template>

<script>
const mapState = window.Vuex.mapState;

import baseService from "./../../../services/index";
import { format, parseISO } from "date-fns";

export default {
  data() {
    return {
      hasNoKEO: true,
      notification: {
        isActive: false,
        message: ""
      },
      ctaData: [
        {
          title: "CPD",
          subContent: "-",
          type: "" // can be filled with is-danger and is-success only
        },
        {
          title: "CPF - Medisave",
          subContent: "-",
          type: "" // can be filled with is-danger and is-success only
        }
      ],
      isFetchingCPDCPFData: true
    };
  },
  computed: {
    ...mapState({
      profileType: state => state.header.userProfile.profileType, //1 for EA, 2 for RES
      apiConfig: state => state.config.configurationData,
      accessToken: state => state.auth.accessToken
    }),
    headerOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
    }
  },
  mounted() {
    this.fetchCPDCPFStatuses();
  },
  methods: {
    fetchCPDCPFStatuses() {
      const endpoint = this.apiConfig.common_module.qualificationManagement
        .getCPDCPFStatus;

      const profileType = this.profileType === 1 ? "entity" : "individual";

      baseService(
        endpoint,
        { type: profileType },
        this.handleFetchStatusesSuccess,
        this.handleFetchStatusesFailed,
        this.headerOptions
      );
    },
    handleFetchStatusesSuccess(response) {
      this.hasNoKEO = false;
      const data = response.data.data;

      this.ctaData.map((cta, idx) => {
        let subContent, type;
        if (cta.title === "CPD") {
          subContent =
            data.cpd && data.cpd.fulfillment
              ? `As of ${data.cpd.fulfillment}`
              : "";
          if (data.cpd && data.cpd.exemptionFlag) type = "is-success";
          else
            type =
              data.cpd &&
              data.cpd.status === "Pass" &&
              parseInt(data.cpd.fulfillment, 10) === new Date().getFullYear()
                ? "is-success"
                : "is-danger";
        } else if (cta.title === "CPF - Medisave") {
          const formattedLastUpdatedDate =
            data.cpf && data.cpf.lastUpdatedDate
              ? format(parseISO(data.cpf.lastUpdatedDate), "dd/MM/yyy HH:mm:ss")
              : null;

          subContent = formattedLastUpdatedDate
            ? `As of ${formattedLastUpdatedDate}`
            : "";

          if (data.cpf && data.cpf.exemptionFlag) type = "is-success";
          else
            type =
              data.cpf && data.cpf.status === "Successful"
                ? "is-success"
                : "is-danger";
        }

        this.$set(this.ctaData, idx, { ...cta, subContent, type });
      });

      this.isFetchingCPDCPFData = false;
    },
    handleFetchStatusesFailed(err) {
      const status = err.response ? err.response.status : null;

      this.ctaData.map((cta, idx) => {
        this.$set(this.ctaData, idx, { ...cta, type: "is-danger" });
      });

      this.isFetchingCPDCPFData = false;

      if (status !== 404) {
        this.hasNoKEO = false;
        this.$set(this.notification, "isActive", true);

        this.$set(
          this.notification,
          "message",
          this.$_globalMixin_errorMessage(err)
        );
      } else {
        this.hasNoKEO = true;
      }
    }
  }
};
</script>

<style></style>
